{
  "about.blocks": "Moderasiya edilmiş serverlər",
  "about.contact": "Əlaqə:",
  "about.default_locale": "İlkin",
  "about.disclaimer": "Mastodon ödənişsiz, açıq-mənbəli yazılımdır və Mastodon gGmbH-nin əmtəə nişanıdır.",
  "about.domain_blocks.no_reason_available": "Səbəb mövcud deyil",
  "about.domain_blocks.preamble": "Mastodon, adətən fediverse-dəki hər hansısa bir serverdən məzmuna baxmağınıza və istifadəçilərlə qarşılıqlı əlaqədə olmağınıza imkanı verir. Bunlar, bu serverdə edilmiş istisnalardır.",
  "about.domain_blocks.silenced.explanation": "Siz bu serverdəki profilləri və məzmunu xüsusi olaraq axtarmasanız və ya izləməsəniz ümumiyyətlə görməyəcəksiniz.",
  "about.domain_blocks.silenced.title": "Məhdudlaşdırılmış",
  "about.domain_blocks.suspended.explanation": "Bu serverdəki heç bir veri emal edilməyəcək, saxlanılmayacaq və ya mübadilə edilməyəcək, bu serverdəki istifadəçilərlə hər hansısa bir qarşılıqlı əlaqə və ya ünsiyyət mümkünsüz olacaq.",
  "about.domain_blocks.suspended.title": "Qadağa qoyulub",
  "about.language_label": "Dil",
  "about.not_available": "Bu məlumat bu serverdə əlçatan edilməyib.",
  "about.powered_by": "{mastodon} tərəfindən təchiz edilən desentralizasiya edilmiş sosial media",
  "about.rules": "Server qaydaları",
  "account.account_note_header": "Şəxsi qeyd",
  "account.activity": "Fəaliyyət",
  "account.add_note": "Fərdi bir not əlavə et",
  "account.add_or_remove_from_list": "Siyahılara əlavə et və ya sil",
  "account.badges.admin": "Admin",
  "account.badges.blocked": "Əngəlləndi",
  "account.badges.bot": "Avtomatlaşdırılmış",
  "account.badges.domain_blocked": "Əngəllənmiş domen",
  "account.badges.group": "Qrup",
  "account.badges.muted": "Səssizdə",
  "account.badges.muted_until": "{until} qədər səssizdə",
  "account.block": "@{name} istifadəçisini blokla",
  "account.block_domain": "{domain} domenini blokla",
  "account.block_short": "Blok",
  "account.blocked": "Bloklanıb",
  "account.cancel_follow_request": "İzləməni ləğv et",
  "account.copy": "Profil linkini kopyala",
  "account.direct": "@{name} istifadəçisini fərdi olaraq etiketlə",
  "account.disable_notifications": "@{name} paylaşım edəndə mənə bildiriş göndərməyi dayandır",
  "account.edit_note": "Fərdi nota düzəliş",
  "account.edit_profile": "Profili redaktə et",
  "account.edit_profile_short": "Düzəliş",
  "account.enable_notifications": "@{name} paylaşım edəndə mənə bildiriş göndər",
  "account.endorse": "Profildə seçilmişlərə əlavə et",
  "account.familiar_followers_many": "{name1}, {name2} və tanıdığınız digər {othersCount, plural, one {digər bir nəfər} other {# nəfər}} izləyir",
  "account.familiar_followers_one": "{name1} izləyir",
  "account.familiar_followers_two": "{name1} və {name2} izləyir",
  "account.featured": "Seçilmiş",
  "account.featured.accounts": "Profillər",
  "account.featured.collections": "Kolleksiyalar",
  "account.featured.new_collection": "Yeni kolleksiya",
  "account.field_overflow": "Tam məzmunu göstər",
  "account.filters.all": "Bütün fəaliyyət",
  "account.filters.boosts_toggle": "Təkrar paylaşmaları göstər",
  "account.filters.posts_boosts": "Göndərişlər və təkrar paylaşmalar",
  "account.filters.posts_only": "Göndərişlər",
  "account.filters.posts_replies": "Göndərişlər və cavablar",
  "account.filters.replies_toggle": "Cavabları göstər",
  "account.follow": "İzlə",
  "account.follow_back": "Sən də izlə",
  "account.follow_back_short": "Geri izlə",
  "account.follow_request": "İzləmə istəyi",
  "account.follow_request_cancel": "İstəyi ləğv et",
  "account.follow_request_cancel_short": "İmtina",
  "account.follow_request_short": "İstək",
  "account.followers": "İzləyicilər",
  "account.followers.empty": "Bu istifadəçini hələ ki, heç kim izləmir.",
  "account.followers_counter": "{count, plural, one {{counter} izləyici} other {{counter} izləyici}}",
  "account.followers_you_know_counter": "bildiyiniz {counter}",
  "account.following": "İzləyir",
  "account.following_counter": "{count, plural, one {{counter} izləyir} other {{counter} izləyir}}",
  "account.follows.empty": "Bu istifadəçi hələ ki, heç kimi izləmir.",
  "account.follows_you": "Sizi izləyir",
  "account.go_to_profile": "Profilə get",
  "account.hide_reblogs": "@{name} - təkrar paylaşımlarını gizlət",
  "account.in_memoriam": "Xatirə.",
  "account.join_modal.day": "Gün",
  "account.join_modal.me": "{server} - qoşuldunuz",
  "account.join_modal.me_anniversary": "Fediversary-niz mübarək! {server} - qoşuldunuz",
  "account.join_modal.me_today": "{server} üzərində ilk gününüzdür!",
  "account.join_modal.other": "{name}, {server} serverinə qoşuldu",
  "account.join_modal.other_today": "{name} - {server} serverində ilk günüdür!",
  "account.join_modal.share.celebrate": "Qeyd etmək üçün göndəriş paylaş",
  "account.join_modal.share.intro": "Tanıtım üçün göndəriş paylaş",
  "account.join_modal.share.welcome": "Xoş gəlmisiniz göndərişi paylaş",
  "account.join_modal.years": "{number, plural, one {il} other {il}}",
  "account.joined_short": "Qoşulub",
  "account.languages": "Abunə olunmuş dilləri dəyiş",
  "account.last_active": "Son aktivlik",
  "account.link_verified_on": "Bu linkin dəqiqliyi {date} tarixində yoxlanılıb",
  "account.locked_info": "Bu hesabın məxfilik statusu kilidlənib. Sahibi, onu kimin izləyə biləcəyini manual olaraq incələyir.",
  "account.media": "Media",
  "account.mention": "@{name} istifadəçisini teq et",
  "account.menu.add_to_list": "Siyahıya əlavə et…",
  "account.menu.block": "Hesabı əngəllə",
  "account.menu.block_domain": "{domain} - əngəllə",
  "account.menu.copied": "Hesab keçidi lövhəyə kopyalandı",
  "account.menu.copy": "Keçidi kopyala",
  "account.menu.direct": "Adını özəl olaraq çək",
  "account.menu.hide_reblogs": "Zaman xəttində təkrar paylaşmaları gizlət",
  "account.menu.mention": "Adçəkmə",
  "account.menu.mute": "Hesabı səssizə al",
  "account.menu.note.description": "Yalnız sizə görünəndir",
  "account.menu.open_original_page": "Burada bax: {domain}",
  "account.menu.remove_follower": "İzləyicini çıxart",
  "account.menu.report": "Hesabı bildir",
  "account.menu.share": "Paylaş…",
  "account.menu.show_reblogs": "Zaman xəttində təkrar paylaşmaları göstər",
  "account.menu.unblock": "Hesabın əngəlini götür",
  "account.moved_to": "{name} onun yeni hesabının artıq bu olduğunu bildirdi:",
  "account.mute": "@{name} istifadəçisini susdur",
  "account.mute_notifications_short": "Bildirişləri səssizləşdir",
  "account.mute_short": "Səssizləşdir",
  "account.muted": "Səssizləşdirilib",
  "account.mutual": "Bir-birinizi izləyirsiniz",
  "account.no_bio": "Təsvir göstərilməyib.",
  "account.open_original_page": "Orijinal səhifəni aç",
  "account.posts": "Paylaşım",
  "account.remove_from_followers": "{name} - izləyicilərdən çıxart",
  "account.report": "@{name} istifadəçisini şikayət et",
  "account.requested_follow": "{name} sizi izləmək sorğusu göndərib",
  "account.share": "@{name} profilini paylaş",
  "account.show_reblogs": "@{name} - təkrar paylaşımlarını göstər",
  "account.statuses_counter": "{count, plural, one {{counter} paylaşım} other {{counter} paylaşım}}",
  "account.unblock": "@{name} blokunu aç",
  "account.unblock_domain": "{domain} domeninin blokunu aç",
  "account.unblock_domain_short": "Əngəldən çıxart",
  "account.unblock_short": "Bloku aç",
  "account.unendorse": "Profildə seçilmişlərə əlavə etmə",
  "account.unfollow": "İzləmədən çıxar",
  "account.unmute": "@{name} səssizləşdirmədən çıxart",
  "account.unmute_notifications_short": "Bildirişlərin səsini aç",
  "account.unmute_short": "Səssizləşdirmədən çıxart",
  "account_edit.field_delete_modal.title": "Özəl xananı sil?",
  "account_edit.field_edit_modal.add_title": "Özəl xana əlavə et",
  "account_edit.field_edit_modal.discard_confirm": "İmtina",
  "account_edit.field_edit_modal.discard_message": "Saxlanılmamış dəyişiklikləriniz var. Onları silmək istədiyinizə əminsiniz?",
  "account_edit.field_edit_modal.edit_title": "Özəl xanaya düzəliş",
  "account_edit.field_edit_modal.length_warning": "Tövsiyə edilən xarakter limiti aşıldı. Mobil istifadəçilər xananızın tamamını görməyə bilər.",
  "account_note.placeholder": "Qeyd əlavə etmək üçün kliklə",
  "admin.dashboard.daily_retention": "Qeydiyyatdan sonrakı günə görə istifadəçi qalma dərəcəsi",
  "admin.dashboard.monthly_retention": "Qeydiyyatdan sonrakı aya görə istifadəçi qalma dərəcəsi",
  "admin.dashboard.retention.average": "Orta",
  "admin.dashboard.retention.cohort": "Qeydiyyatdan keçmə ayı",
  "admin.dashboard.retention.cohort_size": "Yeni istifadəçilər",
  "admin.impact_report.instance_accounts": "Bunun siləcəyi istifadəçi hesabları",
  "admin.impact_report.instance_followers": "İstifadəçilərimizin itirəcəyi izləyici sayı",
  "admin.impact_report.instance_follows": "Onların istifadəçilərinin itirəcəyi izləyici sayı",
  "admin.impact_report.title": "Təsirin xülasəsi",
  "alert.rate_limited.message": "Zəhmət olmasa, {retry_time, time, medium} sonra yenidən cəhd edin.",
  "alert.rate_limited.title": "Sürət limiti",
  "alert.unexpected.message": "Bilinməyən bir xəta baş verdi.",
  "alert.unexpected.title": "Ah!",
  "alt_text_badge.title": "Alternativ mətn",
  "alt_text_modal.add_alt_text": "Alternativ mətn əlavə et",
  "alt_text_modal.add_text_from_image": "Şəkildəki mətni əlavə et",
  "alt_text_modal.cancel": "İmtina",
  "alt_text_modal.change_thumbnail": "Miniatürü dəyişdir",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Eşitmə məhdudiyyətli insanlar üçün bunu izah et…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Görmə məhdudiyyətli insanlar üçün bunu təsvir et…",
  "alt_text_modal.done": "Oldu",
  "announcement.announcement": "Elan",
  "annual_report.summary.most_used_app.most_used_app": "ən çox istifadə etdiyi tətbiq",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "ən çox istifadə etdiyi heşteq",
  "annual_report.summary.new_posts.new_posts": "yeni paylaşım",
  "annual_report.summary.percentile.text": "<topLabel>Bu sizi {domain} istifadəçilərinin ilk</topLabel><percentage></percentage><bottomLabel>qoyur.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Bunu Berniyə deməyəcəyik.",
  "attachments_list.unprocessed": "(emal edilməyib)",
  "audio.hide": "Audionu gizlət",
  "block_modal.remote_users_caveat": "{domain} serverindən qərarınıza hörmət etməsini xahiş edəcəyik. Ancaq, bəzi serverlər əngəlləmələri fərqli şəkildə idarə edə bilər deyə, qərarınıza uymağına zəmanət verilmir. Hər kəsə açıq göndərişlər, hələ də sistemə giriş etməmiş istifadəçilərə görünə bilər.",
  "block_modal.show_less": "Daha az göstər",
  "block_modal.show_more": "Daha çox göstər",
  "block_modal.they_will_know": "O sənin onu blokladığını görə biləcək.",
  "block_modal.title": "İstifadəçi bloklansın?",
  "boost_modal.combo": "Növbəti dəfə bunu atlamaq üçün {combo} klikləyə bilərsən",
  "boost_modal.reblog": "Paylaşım təkrar paylaşılsın?",
  "boost_modal.undo_reblog": "Təkrar paylaşım ləğv edilsin?",
  "bundle_column_error.copy_stacktrace": "Xəta hesabatını kopyala",
  "bundle_column_error.error.body": "Tələb olunan səhifəni göstərmək mümkün olmadı. Bu, kodumuzdakı səhv və ya brauzer uyğunluğu problemi ilə bağlı ola bilər.",
  "bundle_column_error.error.title": "Ah, yox!",
  "bundle_column_error.network.body": "Bu səhifəni yükləməyə çalışarkən xəta baş verdi. Bu, internet bağlantınız və ya bu serverlə bağlı müvəqqəti problemlə əlaqədar ola bilər.",
  "bundle_column_error.network.title": "Şəbəkə xətası",
  "bundle_column_error.retry": "Yenidən cəhd et",
  "bundle_column_error.return": "Ana səhifəyə qayıt",
  "bundle_column_error.routing.body": "Tələb olunan səhifəni tapmaq mümkün olmadı. Ünvan çubuğundakı URL-nin düzgün olduğuna əminsiniz?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Bağla",
  "bundle_modal_error.message": "Bu ekranı yükləyərkən xəta baş verdi.",
  "bundle_modal_error.retry": "Yenidən cəhd et",
  "closed_registrations.other_server_instructions": "Mastodon desentralizasiya edilmiş olduğu üçün başqa bir serverdə hesab yarada və hələ də bu serverdən istifadə edə bilərsiniz.",
  "closed_registrations_modal.description": "{domain} serverində hesab yaratmaq hazırda mümkün deyil, lakin nəzərə alın ki, Mastodondan istifadə etmək üçün xüsusi olaraq {domain} serverində hesaba ehtiyacınız yoxdur.",
  "closed_registrations_modal.find_another_server": "Başqa server tap",
  "closed_registrations_modal.preamble": "Mastodon desentralizasiya edilib, ona görə də hesabınızı harada yaratmağınızdan asılı olmayaraq, siz bu serverdə hər kəsi izləyə və onunla əlaqə saxlaya biləcəksiniz. Siz hətta özünüz server aça bilərsiniz!",
  "closed_registrations_modal.title": "Mastodonda qeydiyyatdan keçmək",
  "column.about": "Haqqında",
  "column.blocks": "Bloklanmış istifadəçilər",
  "column.bookmarks": "Əlfəcinlər",
  "column.community": "Lokal zaman qrafiki",
  "column.create_list": "Siyahı yarat",
  "column.direct": "Fərdi teqlər",
  "column.directory": "Profillər arasında gəz",
  "column.domain_blocks": "Bloklanmış domenlər",
  "column.edit_list": "Siyahını redaktə et",
  "column.favourites": "Sevimlilər",
  "column.firehose": "Canlı lentlər",
  "column.follow_requests": "İzləyici sorğuları",
  "column.home": "Ana səhifə",
  "column.list_members": "Siyahı üzvlərini idarə et",
  "column.lists": "Siyahılar",
  "column.mutes": "Səssizləşdirilmiş istifadəçilər",
  "column.notifications": "Bildirişlər",
  "column.pins": "Sancılmış göndərişlər",
  "column.public": "Federasiya zaman qrafiki",
  "column_back_button.label": "Geriyə",
  "column_header.hide_settings": "Ayarları gizlət",
  "column_header.moveLeft_settings": "Sütunu sola köçür",
  "column_header.moveRight_settings": "Sütunu sağa köçür",
  "column_header.pin": "Bərkit",
  "column_header.show_settings": "Ayarları göstər",
  "column_header.unpin": "Bərkitmə",
  "column_search.cancel": "İmtina",
  "community.column_settings.local_only": "Sadəcə lokalda",
  "community.column_settings.media_only": "Sadəcə media",
  "community.column_settings.remote_only": "Sadəcə uzaq serverlər",
  "compose.language.change": "Dili dəyiş",
  "compose.language.search": "Dil axtar...",
  "compose.published.body": "Paylaşıldı.",
  "compose.published.open": "Bax",
  "compose.saved.body": "Paylaşım yadda saxlandı.",
  "compose_form.direct_message_warning_learn_more": "Ətraflı öyrən",
  "compose_form.encryption_warning": "Mastodondakı paylaşımlar ucdan-uca şifrələnmir. Mastodonda heç bir həssas məlumat paylaşmayın.",
  "compose_form.hashtag_warning": "Bu yazı ictimai olmadığı üçün heç bir heşteqdə göstərilməyəcək. Yalnız açıq yazılar heşteq ilə axtarıla bilər.",
  "compose_form.lock_disclaimer": "Hesabınız {locked} deyil. Sadəcə izləyicilər üçün paylaşımlarınıza baxmaq üçün hər kəs sizi izləyə bilər.",
  "compose_form.lock_disclaimer.lock": "kilidli",
  "compose_form.placeholder": "Ağlınızdan nə keçir?",
  "compose_form.poll.duration": "Sorğunun müddəti",
  "compose_form.poll.multiple": "Çoxlu cavab",
  "compose_form.poll.option_placeholder": "Seçim {number}",
  "compose_form.poll.single": "Tək cavab",
  "compose_form.poll.switch_to_multiple": "Çoxsaylı cavablara icazə vermək üçün sorğunu redaktə et",
  "compose_form.poll.switch_to_single": "Tək cavaba icazə vermək üçün sorğunu redaktə et",
  "compose_form.poll.type": "Stil",
  "compose_form.publish": "Paylaş",
  "compose_form.reply": "Cavabla",
  "compose_form.save_changes": "Güncəllə",
  "compose_form.spoiler.marked": "Məzmun xəbərdarlığını sil",
  "compose_form.spoiler.unmarked": "Məzmun xəbərdarlığı əlavə et",
  "compose_form.spoiler_placeholder": "Məzmun xəbərdarlığı (məcburi deyil)",
  "confirmation_modal.cancel": "İmtina",
  "confirmations.block.confirm": "Blokla",
  "confirmations.delete.confirm": "Sil",
  "confirmations.delete.message": "Bu paylaşımı silmək istədiyinizə əminsiniz?",
  "confirmations.delete.title": "Paylaşım silinsin?",
  "confirmations.delete_list.confirm": "Sil",
  "confirmations.delete_list.message": "Bu siyahını həmişəlik silmək istədiyinizə əminsiniz?",
  "confirmations.delete_list.title": "Siyahı silinsin?",
  "confirmations.discard_draft.confirm": "Silib davam et",
  "confirmations.discard_draft.edit.cancel": "Düzəliş etməyə davam",
  "confirmations.discard_draft.edit.message": "Davam etsəniz, hazırda düzəliş etdiyiniz göndərişdəki bütün dəyişikliklər silinəcək.",
  "confirmations.discard_draft.edit.title": "Göndərişinizə etdiyiniz bütün dəyişikliklər silinsin?",
  "confirmations.discard_draft.post.cancel": "Qaralama kimi davam etdir",
  "confirmations.discard_draft.post.message": "Davam etsəniz, hazırda tərtib etdiyiniz göndəriş silinəcək.",
  "confirmations.discard_draft.post.title": "Qaralama göndərişiniz silinsin?",
  "confirmations.discard_edit_media.confirm": "Ləğv et",
  "confirmations.discard_edit_media.message": "Media təsvirində və ya önizləmədə yadda saxlanmamış dəyişiklikləriniz var, ləğv edilsin?",
  "confirmations.follow_to_list.confirm": "İzlə və siyahıya əlavə et",
  "confirmations.follow_to_list.message": "{name} istifadəçisini siyahıya əlavə etmək üçün onu izləməlisiniz.",
  "confirmations.follow_to_list.title": "İstifadəçini izlə?",
  "confirmations.logout.confirm": "Çıxış et",
  "confirmations.logout.message": "Çıxmaq istədiyinizə əminsiniz?",
  "confirmations.logout.title": "Çıxış edilsin?",
  "confirmations.missing_alt_text.confirm": "Alternativ mətn əlavə et",
  "confirmations.missing_alt_text.message": "Göndərişinizdə alternativ mətn yoxdur. Daha çox insanın məzmununuza erişməsinə kömək etmək üçün açıqlama əlavə edin.",
  "confirmations.missing_alt_text.secondary": "Yenə də paylaş",
  "confirmations.missing_alt_text.title": "Alternativ mətn əlavə edilsin?",
  "confirmations.mute.confirm": "Səssizləşdir",
  "confirmations.redraft.confirm": "Sil və qaralamaya köçür",
  "confirmations.redraft.message": "Bu göndərişi silib yenidən qaralama kimi saxlamaq istədiyinizə əminsiniz? Sevimlilər və təkrar paylaşımlar silinəcək, orijinal göndərişə verilən cavablar isə əlaqəsiz qalacaq.",
  "confirmations.redraft.title": "Paylaşım silinsin & qaralamaya köçürülsün?",
  "confirmations.remove_from_followers.confirm": "İzləyicini çıxart",
  "confirmations.remove_from_followers.message": "{name} sizi izləməyəcək. Davam etmək istədiyinizə əminsiniz?",
  "confirmations.remove_from_followers.title": "İzləyici çıxarılsın?",
  "confirmations.revoke_quote.confirm": "Göndərişi sil",
  "confirmations.revoke_quote.message": "Bu əməliyyatın geri dönüşü yoxdur.",
  "confirmations.revoke_quote.title": "Göndəriş silinsin?",
  "confirmations.unfollow.confirm": "İzləmədən çıxar",
  "content_warning.hide": "Paylaşımı gizlət",
  "content_warning.show": "Yenə də göstər",
  "content_warning.show_more": "Daha çox göstər",
  "conversation.delete": "Söhbəti sil",
  "conversation.mark_as_read": "Oxunmuş kimi qeyd et",
  "conversation.open": "Söhbətə bax",
  "conversation.with": "{names} ilə",
  "copy_icon_button.copied": "Mübadilə buferinə köçürüldü",
  "copypaste.copied": "Kopyalandı",
  "copypaste.copy_to_clipboard": "Lövhəyə kopyala",
  "directory.federated": "Bilinən fediversedən",
  "directory.local": "Sadəcə {domain}",
  "directory.new_arrivals": "Yeni gələnlər",
  "directory.recently_active": "Bayaq aktiv olanlar",
  "disabled_account_banner.account_settings": "Hesab ayarları",
  "disabled_account_banner.text": "Sizin hesabınız {disabledAccount} hal-hazırda deaktiv edilib.",
  "dismissable_banner.community_timeline": "Bunlar, hesabları {domain} serverində yerləşən insanların ən son ictimai paylaşımlarıdır.",
  "dismissable_banner.dismiss": "Bağla",
  "dismissable_banner.public_timeline": "Bunlar, {domain} saytında insanların izlədiyi fediversedəki insanların ən son ictimai paylaşımlarıdır.",
  "domain_block_modal.block": "Serveri blokla",
  "domain_block_modal.block_account_instead": "@{name} istifadəçisini blokla",
  "domain_block_modal.they_can_interact_with_old_posts": "Bu serverdən olan insanlar köhnə paylaşımlarınızla əlaqə qura bilər.",
  "domain_block_modal.they_cant_follow": "Bu serverdən heç kim sizi izləyə bilməz.",
  "domain_block_modal.they_wont_know": "Onlar bloklandıqlarını bilməyəcəklər.",
  "domain_block_modal.title": "Domen bloklansın?",
  "domain_block_modal.you_will_lose_num_followers": "Siz {followersCount, plural, one {{followersCountDisplay} follower} other {{followersCountDisplay} izləyici}} və izlədiyiniz {followingCount, plural, one {{followingCountDisplay} istifadəçini} other {{followingCountDisplay} istifadəçini}} itirəcəksiniz.",
  "domain_block_modal.you_will_lose_relationships": "Bu serverdən olan bütün izləyicilərinizi və izlədiklərinizi itirəcəksiniz.",
  "domain_block_modal.you_wont_see_posts": "Bu serverdən olan paylaşımları və istifadəçilərdən olan bildirişləri görməyəcəksiniz.",
  "domain_pill.activitypub_lets_connect": "Bu, təkcə Mastodonda deyil, həm də müxtəlif sosial tətbiqlərdə insanlarla əlaqə saxlamağa və onlarla ünsiyyət qurmağa imkan verir.",
  "domain_pill.activitypub_like_language": "ActivityPub-ı Mastodonun digər sosial şəbəkələrlə danışdığı dil kimi düşünə bilərsiniz.",
  "domain_pill.server": "Server",
  "domain_pill.their_handle": "Tanıdıcısı:",
  "domain_pill.their_server": "Onların bütün paylaşımlarının yaşadığı rəqəmsal ev.",
  "domain_pill.their_username": "Serverdəki unikal identifikator. Fərqli serverlərdə eyni istifadəçi adı ilə istifadəçilər tapmaq mümkündür.",
  "domain_pill.username": "İstifadəçi adı",
  "domain_pill.whats_in_a_handle": "Tanıdıcı nədir?",
  "domain_pill.who_they_are": "Tanıdıcılar kimin kim olduğunu və harada olduğunu bildirdiyi üçün siz <button>ActivityPub tərəfindən dəstəklənən platformaların</button> sosial şəbəkəsindəki bütün insanlarla əlaqə saxlaya bilərsiniz.",
  "domain_pill.who_you_are": "Tanıdıcılar sizin kim olduğunuzu və harada olduğunuzu bildirdiyi üçün <button>ActivityPub tərəfindən dəstəklənən platformaların</button> sosial şəbəkəsindəki bütün insanlar sizlə əlaqə saxlaya bilər.",
  "domain_pill.your_handle": "Tanıdıcınız:",
  "domain_pill.your_server": "Bütün paylaşımlarınızın yaşadığı rəqəmsal ev. Buranı bəyənmirsiniz? İstədiyiniz vaxt serverdən köçün və izləyicilərinizi də aparın.",
  "domain_pill.your_username": "Serverdəki unikal identifikatoruz. Fərqli serverlərdə eyni istifadəçi adı ilə istifadəçilər tapmaq mümkündür.",
  "dropdown.empty": "Bir seçim et",
  "embed.instructions": "Aşağıdakı kodu kopyalayaraq bu postu veb-saytınıza yerləşdirin.",
  "embed.preview": "Belə görünəcək:",
  "emoji_button.activity": "Aktivlik",
  "emoji_button.clear": "Təmizlə",
  "emoji_button.custom": "Özəl",
  "emoji_button.flags": "Bayraqlar",
  "emoji_button.food": "Yemək və içki",
  "emoji_button.label": "Emoji daxil et",
  "emoji_button.nature": "Təbiət",
  "emoji_button.not_found": "Uyuşan emoji tapılmadı",
  "emoji_button.objects": "Obyektlər",
  "emoji_button.people": "İnsanlar",
  "emoji_button.recent": "Tez-tez istifadə edilən",
  "emoji_button.search": "Axtar...",
  "emoji_button.search_results": "Axtarış nəticələri",
  "emoji_button.symbols": "Simvollar",
  "emoji_button.travel": "Səyahət və məkanlar",
  "empty_column.account_hides_collections": "Bu istifadəçi bu məlumatı əlçatan etməməyi seçib",
  "empty_column.account_suspended": "Hesab silinib",
  "empty_column.account_timeline": "Heç bir paylaşım yoxdur!",
  "empty_column.account_unavailable": "Profil əlçatan deyil",
  "empty_column.blocks": "Hələ ki, heç bir istifadəçini bloklamamasınız.",
  "empty_column.bookmarked_statuses": "Hələ ki, heç bir paylaşımı yadda saxlamamısınız. Yadda saxlayanda burada görünəcək.",
  "empty_column.community": "Lokal zaman qrafiki boşdur. Topun yuvarlanmağa başlaması üçün ictimai bir şey paylaşın!",
  "empty_column.direct": "Gizli etiketiniz yoxdur. Göndərdikdə və ya qəbul etdikdə burada görəcəksiniz.",
  "empty_column.domain_blocks": "Hələ ki, bloklanmış domen yoxdur.",
  "empty_column.explore_statuses": "Hal-hazırda trenddə heç yoxdur. Daha sonra yenidən yoxlayın!",
  "empty_column.favourited_statuses": "Bəyəndiyiniz paylaşımlar yoxdur. Birini bəyəndikdə burada görünəcək.",
  "empty_column.favourites": "Bu paylaşımı hələ ki, heç kim bəyənməyib. Bəyənildikdə burada görünəcək.",
  "empty_column.follow_requests": "İzləmə sorğularınız yoxdur. Qəbul etdikdə burada görəcəksiniz.",
  "empty_column.followed_tags": "Heç bir heşteq izləmirsiniz. İzlədikdə burada görünəcək.",
  "empty_column.hashtag": "Bu heşteqdə hələ ki, heç nə yoxdur.",
  "empty_column.home": "Əsas zaman xəttiniz boşdur! Doldurmaq üçün bir neçə istifadəçini izləyin.",
  "empty_column.list": "Hələ bu siyahıda heç nə yoxdur. Bu siyahıdakı üzvlər yeni göndəriş paylaşdığı zaman burada görünəcək.",
  "empty_column.mutes": "Hələ heç bir istifadəçini səssizə almamısınız.",
  "empty_column.notification_requests": "Hamısı hazırdır! Burada heç nə yoxdur. Yeni bildiriş aldığınız zaman, ayarlarınıza görə burada görünəcək.",
  "empty_column.notifications": "Hələ heç bir bildirişiniz yoxdur. Başqaları sizinlə qarşılıqlı əlaqə qurduğu zaman, onu burada görəcəksiniz.",
  "empty_column.public": "Burada hələ heç nə yoxdur! Buranı doldurmaq üçün hər kəsə açıq bir şey yazın və ya digər serverlərdəki istifadəçiləri izləyin.",
  "error.unexpected_crash.explanation": "Kodumuzdakı bir xətaya, ya da brauzer uyumluluq probleminə görə, bu səhifə düzgün nümayiş etdirilə bilmədi.",
  "error.unexpected_crash.explanation_addons": "Bu səhifə düzgün nümayiş etdirilə bilmədi. Bu xəta, yəqin ki, brauzer əlavəsi və ya avtomatik tərcümə alətlərindən qaynaqlanır.",
  "error.unexpected_crash.next_steps": "Səhifəni təzələməyi sınayın. Bu kömək etməzsə, Mastodon-u başqa bir brauzer və ya yerli tətbiq vasitəsilə istifadə edə bilərsiniz.",
  "error.unexpected_crash.next_steps_addons": "Onları sıradan çıxartmağı və səhifəni təzələməyi sınayın. Bu kömək etməzsə, Mastodon-u başqa bir brauzer və ya yerli tətbiq vasitəsilə istifadə edə bilərsiniz.",
  "errors.unexpected_crash.report_issue": "Problemi bildir",
  "explore.suggested_follows": "İnsanlar",
  "explore.title": "Trendlər",
  "explore.trending_links": "Xəbərlər",
  "explore.trending_statuses": "Göndərişlər",
  "explore.trending_tags": "Mövzu etiketləri",
  "featured_carousel.header": "{count, plural, one {Sancılmış göndəriş} other {Sancılmış göndərişlər}}",
  "filter_modal.added.context_mismatch_explanation": "Bu filtr kateqoriyası, bu göndərişdə erişdiyiniz kontekstə aid deyil. Əgər göndərişin bu kontekstdə də filtrlənməsini istəyirsinizsə, filtrə düzəliş etməyiniz lazımdır.",
  "filter_modal.added.context_mismatch_title": "Kontekst uyuşmur!",
  "filter_modal.added.expired_explanation": "Bu filtr kateqoriyasının vaxtı bitib, filtri tətbiq etmək üçün bitmə tarixini dəyişdirməlisiniz.",
  "filter_modal.added.expired_title": "Vaxtı bitmiş filtr!",
  "filter_modal.added.review_and_configure": "Bu filt kateqoriyasını incələmək və daha detallı konfiqurasiya etmək üçün {settings_link} ünvanına gedin.",
  "filter_modal.added.review_and_configure_title": "Filtr ayarları",
  "filter_modal.added.settings_link": "ayarlar səhifəsi",
  "filter_modal.added.short_explanation": "Bu göndəriş, aşağıdakı filtr kateqoriyasına əlavə edilib: {title}.",
  "filter_modal.added.title": "Filtr əlavə edilib!",
  "filter_modal.select_filter.context_mismatch": "bu kontektsə tətbiq olunmur",
  "filter_modal.select_filter.expired": "müddəti bitib",
  "filter_modal.select_filter.prompt_new": "Yeni kateqoriya: {name}",
  "filter_modal.select_filter.search": "Axtar və ya yarat",
  "filter_modal.select_filter.subtitle": "Mövcud bir kateqoriyanı istifadə et, ya da yenisini yarat",
  "filter_modal.select_filter.title": "Bu göndərişi filtrlə",
  "filter_modal.title.status": "Bir göndərişi filtrlə",
  "filter_warning.matches_filter": "“<span>{title}</span>” filtri ilə uyuşur",
  "filtered_notifications_banner.pending_requests": "Tanıdığınız {count, plural, =0 {heç kimdən} one {bir şəxsdən} other {# şəxsdən}}",
  "filtered_notifications_banner.title": "Filtrlənmiş bildirişlər",
  "firehose.all": "Hamısı",
  "firehose.local": "Bu server",
  "firehose.remote": "Digər serverlər",
  "follow_request.authorize": "Səlahiyyət ver",
  "follow_request.reject": "Rədd et",
  "follow_requests.unlocked_explanation": "Hesabınız kilidli olmasa da, {domain} heyəti bu hesabların izləmə tələblərini manual olaraq incələmək istəyə biləcəyinizi düşündü.",
  "follow_suggestions.curated_suggestion": "Heyətin seçimi",
  "follow_suggestions.dismiss": "Təkrar göstərmə",
  "follow_suggestions.featured_longer": "{domain} komandası tərəfindən əllə seçildi",
  "follow_suggestions.friends_of_friends_longer": "İzlədiyiniz insanlar arasında məşhur",
  "follow_suggestions.hints.featured": "Bu profil {domain} komandası tərəfindən əllə seçilib.",
  "follow_suggestions.hints.friends_of_friends": "Bu profil izlədiyiniz insanlar arasında populyardır.",
  "follow_suggestions.hints.most_followed": "Bu profil {domain} serverində ən çox izlənilənlərdən biridir.",
  "follow_suggestions.hints.most_interactions": "Bu profil son zamanlar {domain} üzərində çox diqqət çəkir.",
  "follow_suggestions.hints.similar_to_recently_followed": "Bu profil, son vaxtlar izlədiyiniz profillərə bənzəyir.",
  "follow_suggestions.personalized_suggestion": "Fərdiləşdirilmiş təklif",
  "follow_suggestions.popular_suggestion": "Məşhur təklif",
  "follow_suggestions.popular_suggestion_longer": "{domain} üzərində məşhur",
  "follow_suggestions.similar_to_recently_followed_longer": "Son zaman izlədiyiniz profillərə oxşar",
  "follow_suggestions.view_all": "Hamısına bax",
  "follow_suggestions.who_to_follow": "İzləyə bilərsən",
  "followed_tags": "İzlənilən mövzu etiketləri",
  "footer.about": "Haqqında",
  "footer.directory": "Profil kataloqu",
  "footer.get_app": "Tətbiqi əldə et",
  "footer.keyboard_shortcuts": "Klaviatura qısayolları",
  "footer.privacy_policy": "Gizlilik siyasəti",
  "footer.source_code": "Mənbə koduna bax",
  "footer.status": "Status",
  "footer.terms_of_service": "Xidmət şərtləri",
  "generic.saved": "Saxlanıldı",
  "getting_started.heading": "Başlayaq",
  "hashtag.admin_moderation": "#{name} üçün moderasiya interfeysini aç",
  "hashtag.browse": "#{hashtag} göndərişlərinə bax",
  "hashtag.browse_from_account": "@{name} - #{hashtag} göndərişlərinə bax",
  "hashtag.column_header.tag_mode.all": "və {additional}",
  "hashtag.column_header.tag_mode.any": "və ya {additional}",
  "hashtag.column_header.tag_mode.none": "{additional} olmadan",
  "hashtag.column_settings.select.no_options_message": "Heç bir təklif tapılmadı",
  "hashtag.column_settings.select.placeholder": "Mövzu etiketlərini daxil edin…",
  "hashtag.column_settings.tag_mode.all": "Bunların hamısı",
  "hashtag.column_settings.tag_mode.any": "Bunlardan hər hansısa biri",
  "hashtag.column_settings.tag_mode.none": "Bunların heç biri",
  "hashtag.column_settings.tag_toggle": "Bu sütun üçün əlavə etiketləri daxil et",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} iştirakçı} other {{counter} iştirakçı}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} göndəriş} other {{counter} göndəriş}}",
  "hashtag.counter_by_uses_today": "Bu gün {count, plural, one {{counter} göndəriş} other {{counter} göndəriş}}",
  "hashtag.feature": "Profildə önə çıxart",
  "hashtag.follow": "Mövzu etiketini izlə",
  "hashtag.mute": "#{hashtag} - səssizə al",
  "hashtag.unfeature": "Profildə önə çıxarılmasın",
  "hashtag.unfollow": "Mövzu etiketini izləmə",
  "hashtags.and_other": "…və daha {count, plural, one {}other {# ədəd}}",
  "hints.profiles.followers_may_be_missing": "Bu profilin izləyiciləri əskik ola bilər.",
  "hints.profiles.follows_may_be_missing": "Bu profilin izləyənləri əskik ola bilər.",
  "hints.profiles.posts_may_be_missing": "Bu profilin bəzi göndərişləri əskik ola bilər.",
  "hints.profiles.see_more_followers": "{domain} üzərində daha çox izləyici gör",
  "hints.profiles.see_more_follows": "{domain} üzərində izlənilən gör",
  "hints.profiles.see_more_posts": "{domain} üzərində daha çox göndəriş gör",
  "home.column_settings.show_quotes": "Sitatları göstər",
  "home.column_settings.show_reblogs": "Təkrar paylaşmaları göstər",
  "home.column_settings.show_replies": "Cavabları göstər",
  "home.hide_announcements": "Elanları gizlət",
  "home.pending_critical_update.body": "Lütfən Mastodon serverinizi mümkün olan ən qısa müddətdə güncəlləyin!",
  "home.pending_critical_update.link": "Güncəlləmələrə bax",
  "home.pending_critical_update.title": "Kritik güvənlik güncəlləməsi mövcuddur!",
  "home.show_announcements": "Elanları göstər",
  "ignore_notifications_modal.disclaimer": "Mastodon, bildirişlərini yox saydığınız istifadəçiləri məlumatlandırmır. Bildirişləri yox saymaq, mesajların göndərilməsini dayandırmayacaq.",
  "ignore_notifications_modal.filter_instead": "Əvəzinə filtrlə",
  "ignore_notifications_modal.filter_to_act_users": "Hələ də istifadəçiləri qəbul edə, rədd edə və ya bildirə bilərsiniz",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtrləmə, mümkün çaşqınlığın qarşısını almağa kömək edir.",
  "ignore_notifications_modal.filter_to_review_separately": "Filtrlənmiş bildirişləri ayrı-ayrı incələyə bilərsiniz",
  "ignore_notifications_modal.ignore": "Bildirişləri yox say",
  "ignore_notifications_modal.limited_accounts_title": "Moderasiya edilmiş hesabların bildirişləri yox sayılsın?",
  "ignore_notifications_modal.new_accounts_title": "Yeni hesabların bildirişləri yox sayılsın?",
  "ignore_notifications_modal.not_followers_title": "Sizi izləməyən şəxslərin bildirişləri yox sayılsın?",
  "ignore_notifications_modal.not_following_title": "İzləmədiyiniz şəxslərin bildirişləri yox sayılsın?",
  "ignore_notifications_modal.private_mentions_title": "İstənilməyən Şəxsi Adçəkmələrdən gələn bildirişlər yox sayılsın?",
  "info_button.label": "Kömək",
  "interaction_modal.go": "Get",
  "interaction_modal.no_account_yet": "Hələ heç bir hesabınız yoxdur?",
  "interaction_modal.on_another_server": "Fərqli bir serverdə",
  "interaction_modal.on_this_server": "Bu serverdə",
  "interaction_modal.username_prompt": "Məs: {example}",
  "intervals.full.days": "{number, plural, one {# gün} other {# gün}}",
  "intervals.full.hours": "{number, plural, one {# saat} other {# saat}}",
  "intervals.full.minutes": "{number, plural, one {# dəqiqə} other {# dəqiqə}}",
  "keyboard_shortcuts.back": "Geri get",
  "keyboard_shortcuts.blocked": "Əngəllənən istifadəçilərin siyahısını aç",
  "keyboard_shortcuts.boost": "Göndərişi təkrar paylaş",
  "keyboard_shortcuts.column": "Sütuna fokuslan",
  "keyboard_shortcuts.compose": "Mətn yazma sahəsinə fokuslan",
  "keyboard_shortcuts.description": "Açıqlama",
  "keyboard_shortcuts.down": "Siyahıda aşağı daşı",
  "keyboard_shortcuts.enter": "Göndərişi aç",
  "keyboard_shortcuts.favourite": "Göndərişi sevimlilərə əlavə et",
  "keyboard_shortcuts.favourites": "Sevimli siyahını aç",
  "keyboard_shortcuts.heading": "Klaviatura qısayolları",
  "keyboard_shortcuts.home": "Əsas ekran zaman xəttini aç",
  "keyboard_shortcuts.hotkey": "Qısayol düyməsi",
  "keyboard_shortcuts.legend": "Bu əfsanəni nümayiş etdir",
  "keyboard_shortcuts.local": "Lokal zaman xəttini aç",
  "keyboard_shortcuts.mention": "Müəllifin adını çək",
  "keyboard_shortcuts.muted": "Səssizdəki istifadəçilərin siyahısını aç",
  "keyboard_shortcuts.my_profile": "Profilinizi açın",
  "keyboard_shortcuts.notifications": "Bildirişlər sütununu aç",
  "keyboard_shortcuts.open_media": "Medianı aç",
  "keyboard_shortcuts.pinned": "Sancılmış göndərişlərin siyahısını aç",
  "keyboard_shortcuts.profile": "Müəllifin profilini aç",
  "keyboard_shortcuts.reply": "Göndərişə cavab ver",
  "keyboard_shortcuts.requests": "İzləmə istəyi siyahısını aç",
  "keyboard_shortcuts.search": "Axtarış çubuğuna fokuslan",
  "keyboard_shortcuts.spoilers": "CW xanasını göstər/gizlət",
  "keyboard_shortcuts.start": "\"Başlayaq\" sütununu aç",
  "keyboard_shortcuts.toggle_hidden": "CW arxasındakı mətni göstər/gizlət",
  "keyboard_shortcuts.toggle_sensitivity": "Medianı göstər/gizlət",
  "keyboard_shortcuts.toot": "Yeni bir göndəriş başlat",
  "keyboard_shortcuts.translate": "bir göndərişi tərcümə etmək üçün",
  "keyboard_shortcuts.unfocus": "Fokusu göndəriş yazma xanasından/axtarışdan götür",
  "keyboard_shortcuts.up": "Siyahıda yuxarı daşı",
  "learn_more_link.got_it": "Anladım",
  "learn_more_link.learn_more": "Daha ətraflı",
  "lightbox.close": "Bağla",
  "lightbox.next": "Növbəti",
  "lightbox.previous": "Əvvəlki",
  "lightbox.zoom_in": "Həqiqi ölçüyə qayıt",
  "lightbox.zoom_out": "Sığacaq şəkildə yaxınlaşdır",
  "limited_account_hint.action": "Yenə də profili göstər",
  "limited_account_hint.title": "Bu profil, {domain} moderatorları tərəfindən gizlədildi.",
  "link_preview.author": "Müəllif: {name}",
  "link_preview.more_from_author": "{name} - daha çox",
  "link_preview.shares": "{count, plural, one {{counter} göndəriş} other {{counter} göndəriş}}",
  "lists.add_member": "Əlavə et",
  "lists.add_to_list": "Siyahıya əlavə et",
  "lists.add_to_lists": "{name} - siyahılara əlavə et",
  "lists.create": "Yarat",
  "lists.create_a_list_to_organize": "Əsas ekran lentinizi təşkil etmək üçün yeni bir siyahı yaradın",
  "lists.create_list": "Siyahı yarat",
  "lists.delete": "Siyahını sil",
  "lists.done": "Hazırdır",
  "lists.edit": "Siyahıya düzəliş et",
  "lists.exclusive": "Əsas ekranda üzvləri gizlət",
  "lists.exclusive_hint": "Kimsə bu siyahıdadırsa, onun göndərişləri bir dəfədən çox görünməməsi üçün Əsas ekran lentində gizlədilir.",
  "lists.find_users_to_add": "Əlavə ediləcək istifadəçiləri tap",
  "lists.list_members_count": "{count, plural, one {# üzv} other {# üzv}}",
  "lists.list_name": "Siyahı adı",
  "lists.new_list_name": "Yeni siyahı adı",
  "lists.no_lists_yet": "Hələ siyahı yoxdur.",
  "lists.no_members_yet": "Hələ üzv yoxdur.",
  "lists.no_results_found": "Heç bir nəticə tapılmadı.",
  "lists.remove_member": "Çıxart",
  "lists.replies_policy.followed": "İstənilən izlənilən istifadəçi",
  "lists.replies_policy.list": "Siyahıdakı üzvlər",
  "lists.replies_policy.none": "Heç kim",
  "lists.save": "Saxla",
  "lists.search": "Axtar",
  "lists.show_replies_to": "Siyahı üzvlərinin cavablarını daxil et",
  "load_pending": "{count, plural, one {# yeni element} other {# yeni element}}",
  "loading_indicator.label": "Yüklənir…",
  "media_gallery.hide": "Gizlət",
  "moved_to_account_banner.text": "{disabledAccount} hesabınız, {movedToAccount} hesabına keçdiyiniz üçün hazırda sıradan çıxarılıb.",
  "mute_modal.hide_from_notifications": "Bildirişlərdə gizlət",
  "mute_modal.hide_options": "Seçimləri gizlət",
  "mute_modal.indefinite": "Mən səsini açana qədər",
  "mute_modal.show_options": "Seçimləri göstər",
  "mute_modal.they_can_mention_and_follow": "Sizin adınızı çəkə və sizi izləyə bilər, ancaq siz onları görə bilməzsiniz.",
  "mute_modal.they_wont_know": "Onlar, səssizə alındıqlarını bilməyəcəklər.",
  "mute_modal.title": "İstifadəçi səssizə alınsın?",
  "mute_modal.you_wont_see_mentions": "Onların adı çəkilən göndərişləri görməyəcəksiniz.",
  "mute_modal.you_wont_see_posts": "Onlar hələ də göndərişlərinizi görə biləcək, ancaq onların göndərişlərini görməyəcəksiniz.",
  "navigation_bar.about": "Haqqında",
  "navigation_bar.account_settings": "Parol və təhlükəsizlik",
  "navigation_bar.administration": "Administrasiya",
  "navigation_bar.advanced_interface": "Qabaqcıl veb interfeysində aç",
  "navigation_bar.automated_deletion": "Göndərişin avtomatik silinməsi",
  "navigation_bar.blocks": "Əngəllənmiş istifadəçilər",
  "navigation_bar.bookmarks": "Əlfəcinlər",
  "navigation_bar.direct": "Şəxsi adçəkmələr",
  "navigation_bar.domain_blocks": "Əngəllənmiş domenlər",
  "navigation_bar.favourites": "Sevimlilər",
  "navigation_bar.filters": "Səssizə alınmış sözlər",
  "navigation_bar.follow_requests": "İzləmə istəkləri",
  "navigation_bar.followed_tags": "İzlənilən mövzu etiketləri",
  "navigation_bar.follows_and_followers": "İzlənilənlər və izləyicilər",
  "navigation_bar.import_export": "Daxilə və xaricə köçürmə",
  "navigation_bar.lists": "Siyahılar",
  "navigation_bar.live_feed_local": "Canlı lent (lokal)",
  "navigation_bar.live_feed_public": "Canlı lent (hər kəsə açıq)",
  "navigation_bar.logout": "Çıxış",
  "navigation_bar.moderation": "Moderasiya",
  "navigation_bar.more": "Daha çox",
  "navigation_bar.mutes": "Səssizə alınmış istifadəçilər",
  "navigation_bar.opened_in_classic_interface": "Göndərişlər, hesablar və digər müəyyən səhifələr klassik veb interfeysində ilkin olaraq açılır.",
  "navigation_bar.preferences": "Tərcihlər",
  "navigation_bar.privacy_and_reach": "Gizlilik və əlçatanlıq",
  "navigation_bar.search": "Axtar",
  "navigation_bar.search_trends": "Axtar / Trendlər",
  "navigation_panel.collapse_followed_tags": "İzlənilən mövzu etiketləri menyusunu yığcamlaşdır",
  "navigation_panel.collapse_lists": "Siyahı menyusunu yığcamlaşdır",
  "navigation_panel.expand_followed_tags": "İzlənilən mövzu etiketləri menyusunu genişləndir",
  "navigation_panel.expand_lists": "Siyahı menyusunu genişləndir",
  "not_signed_in_indicator.not_signed_in": "Bu resursa erişmək üçün giriş etməlisiniz.",
  "notification.admin.report": "{name} şikayət etdi: {target}",
  "notification.admin.report_account": "{name}, {category} üçün şikayət etdi: {target} - {count, plural, one {bir göndəriş} other {# göndəriş}}",
  "notification.admin.report_account_other": "{name} şikayət etdi: {target} - {count, plural, one {bir göndəriş} other {# göndəriş}}",
  "notification.admin.report_statuses": "{name}, {category} üçün şikayət etdi: {target}",
  "notification.admin.report_statuses_other": "{name} şikayət etdi: {target}",
  "notification.admin.sign_up": "{name} qeydiyyatdan keçib",
  "notification.admin.sign_up.name_and_others": "{name} və digər {count, plural, one {# nəfər} other {# nəfər}} qeydiyyatdan keçib",
  "notification.annual_report.view": "#Wrapstodon-a bax",
  "notification.favourite": "{name} göndərişinizi sevimlilərinə əlavə etdi",
  "notification.favourite.name_and_others_with_link": "{name} və digər <a>{count, plural, one {# nəfər} other {# nəfər}}</a> göndərişinizi sevimlilərinə əlavə etdi",
  "notification.favourite_pm": "{name}, şəxsi adçəkmənizi sevimlilərinə əlavə etdi",
  "notification.favourite_pm.name_and_others_with_link": "{name} və digər <a>{count, plural, one {# nəfər} other {# nəfər}}</a> şəxsi adçəkmənizi sevimlilərinə əlavə etdi",
  "notification.follow": "{name} sizi izləyir",
  "notification.follow.name_and_others": "{name} və digər <a>{count, plural, one {# nəfər} other {# nəfər}}</a> sizi izləyir",
  "notification.follow_request": "{name} sizi izləmək üçün istək göndərdi",
  "notification.follow_request.name_and_others": "{name} və digər {count, plural, one {# nəfər} other {# nəfər}} sizi izləmək üçün istək göndərdi",
  "notification.label.mention": "Adçəkmə",
  "notification.label.private_mention": "Şəxsi adçəkmə",
  "notification.label.private_reply": "Şəxsi cavab",
  "notification.label.quote": "{name} göndərişinizi sitat gətirdi",
  "notification.label.reply": "Cavab",
  "notification.mention": "Adçəkmə",
  "notification.mentioned_you": "{name} adınızı çəkdi",
  "notification.moderation-warning.learn_more": "Daha ətraflı",
  "notification.moderation_warning": "Bir moderasiya xəbərdarlığı aldınız",
  "notification.moderation_warning.action_delete_statuses": "Bəzi göndərişləriniz silindi.",
  "notification.moderation_warning.action_disable": "Hesabınız sıradan çıxarılıb.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Bəzi göndərişləriniz həssas olaraq işarələnib.",
  "notification.moderation_warning.action_none": "Hesabınız bir moderasiya xəbərdarlığı aldı.",
  "notification.moderation_warning.action_sensitive": "Göndərişləriniz artıq həssas olaraq işarələnəcək.",
  "notification.moderation_warning.action_silence": "Hesabınız məhdudlaşdırılıb.",
  "notification.moderation_warning.action_suspend": "Hesabınızın fəaliyyəti dayandırılıb.",
  "notification.own_poll": "Anketiniz bitdi",
  "notification.poll": "Səs verdiyiniz anket bitdi",
  "notification.reblog": "{name} göndərişinizi təkrar paylaşdı",
  "notification.reblog.name_and_others_with_link": "{name} və <a>{count, plural, one {digər # nəfər} other {digər # nəfər}}</a> göndərişinizi təkrar paylaşdı",
  "notification.relationships_severance_event": "{name} ilə bağlantı qopdu",
  "notification.relationships_severance_event.account_suspension": "{from} admini {target} fəaliyyətini dayandırıb, bu da o deməkdir ki, artıq onlardan güncəlləmələr ala və ya onlarla qarşılıqlı əlaqə qura bilməyəcəyiniz.",
  "notification.relationships_severance_event.domain_block": "{target}, {from} admini tərəfindən əngəllənib, buna {followersCount} izləyiciniz və izlədiyiniz {followingCount, plural, one {# hesab} other {# hesab}} daxildir.",
  "notification.relationships_severance_event.learn_more": "Daha ətraflı",
  "notification.relationships_severance_event.user_domain_block": "{target} əngəlləmisiniz, bununla {followersCount} izləyiciniz və izlədiyiniz {followingCount, plural, one {# hesab} other {# hesab}} silinib.",
  "notification.status": "{name} indicə paylaşdı",
  "notification.update": "{name} bir göndərişə düzəliş etdi",
  "notification_requests.accept": "Qəbul et",
  "notification_requests.accept_multiple": "{count, plural, one {# istəyi qəbul et…} other {# istəyi qəbul et…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {İstəyi qəbul et} other {İstəkləri qəbul et}}",
  "notification_requests.confirm_accept_multiple.message": "{count, plural, one {Bir bildiriş istəyini} other {# bildiriş istəklərini}} qəbul etmək üzrəsiniz. Davam etmək istədiyinizə əminsiniz?",
  "notification_requests.confirm_accept_multiple.title": "Bildiriş istəkləri qəbul edilsin?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {İstəyi rədd et} other {İstəkləri rədd et}}",
  "notification_requests.confirm_dismiss_multiple.message": "{count, plural, one {bir bildiriş sorğusunu} other {# bildiriş sorğusunu}} bağlamaq üzrəsiniz. {count, plural, one {Ona} other {Onlara}} yenidən asanlıqla erişə bilməyəcəksiniz. Davam etmək istədiyinizə əminsiniz?",
  "notification_requests.confirm_dismiss_multiple.title": "Bildiriş istəklərinə rədd cavabı verilsin?",
  "notification_requests.dismiss": "Rədd et",
  "notification_requests.dismiss_multiple": "{count, plural, one {# istəyi rədd et…} other {# istəyi rədd et…}}",
  "notification_requests.edit_selection": "Düzəliş et",
  "notification_requests.exit_selection": "Hazırdır",
  "notification_requests.explainer_for_limited_account": "Hesab, bir moderator tərəfindən məhdudlaşdırıldığı üçün bu hesabın bildirişləri filtrləndi.",
  "notification_requests.explainer_for_limited_remote_account": "Hesab və ya onun serveri, bir moderator tərəfindən məhdudlaşdırıldığı üçün bu hesabın bildirişləri filtrləndi.",
  "notification_requests.maximize": "Böyüt",
  "notification_requests.minimize_banner": "Filtrlənmiş bildirişlər bannerini kiçilt",
  "notification_requests.notifications_from": "{name} - bildirişləri",
  "notification_requests.title": "Filtrlənmiş bildirişlər",
  "notification_requests.view": "Bildirişlərə bax",
  "notifications.clear": "Bildirişləri təmizlə",
  "notifications.clear_confirmation": "Bütün bildirişlərinizi həmişəlik təmizləmək istədiyinizə əminsiniz?",
  "notifications.clear_title": "Bildirişlər təmizlənsin?",
  "notifications.column_settings.admin.report": "Yeni hesabatlar:",
  "notifications.column_settings.admin.sign_up": "Yeni qeydiyyatlar:",
  "notifications.column_settings.alert": "Masaüstü bildirişlər",
  "notifications.column_settings.favourite": "Sevimlilər:",
  "notifications.column_settings.filter_bar.advanced": "Bütün kateqoriyaları nümayiş etdir",
  "notifications.column_settings.filter_bar.category": "Cəld filtr çubuğu",
  "notifications.column_settings.follow": "Yeni izləyicilər:",
  "notifications.column_settings.follow_request": "Yeni izləmə istəkləri:",
  "notifications.column_settings.group": "Qrup",
  "notifications.column_settings.mention": "Adçəkmələr:",
  "notifications.column_settings.poll": "Anket nəticələri:",
  "notifications.column_settings.push": "Ani bildirişlər",
  "notifications.column_settings.quote": "Sitatlar:",
  "notifications.column_settings.reblog": "Təkrar paylaşmalar:",
  "notifications.column_settings.show": "Sütunda göstər",
  "notifications.column_settings.sound": "Səs oxut",
  "notifications.column_settings.status": "Yeni göndərişlər:",
  "notifications.column_settings.unread_notifications.category": "Oxunmamış bildirişlər",
  "notifications.column_settings.unread_notifications.highlight": "Oxunmamış bildirişləri vurğula",
  "notifications.column_settings.update": "Düzəlişlər:",
  "notifications.filter.all": "Hamısı",
  "notifications.filter.boosts": "Təkrar paylaşmalar",
  "notifications.filter.favourites": "Sevimlilər",
  "notifications.filter.follows": "İzlənilənlər",
  "notifications.filter.mentions": "Adçəkmələr",
  "notifications.filter.polls": "Anket nəticələri",
  "notifications.filter.statuses": "İzlədiyiniz şəxslərdən güncəlləmələr",
  "notifications.grant_permission": "İcazəni ver.",
  "notifications.group": "{count} bildiriş",
  "notifications.mark_as_read": "Hər bir bildiriş oxunmuş olaraq işarələ",
  "notifications.permission_denied": "Brauzer icazələri istəyinə daha əvvəl rədd cavabı verildiyi üçün masaüstü bildirişləri əlçatmazdır",
  "notifications.permission_denied_alert": "Brauzer icazəsinə daha əvvəl rədd cavabı verildiyi üçün masaüstü bildirişləri fəallaşdırıla bilmir",
  "notifications.permission_required": "Tələb olunan icazə verilmədiyi üçün masaüstü bildirişləri əlçatmazdır.",
  "notifications.policy.accept": "Qəbul et",
  "notifications.policy.accept_hint": "Bildirişlərdə göstər",
  "notifications.policy.drop": "Yox say",
  "notifications.policy.filter": "Filtr",
  "notifications.policy.filter_hint": "Filtrlənmiş bildirişlər gələn qutusuna göndər",
  "notifications.policy.filter_limited_accounts_hint": "Server moderatorları tərəfindən məhdudlaşdırılıb",
  "notifications.policy.filter_limited_accounts_title": "Moderasiya edilmiş hesablar",
  "notifications.policy.filter_new_accounts.hint": "Son {days, plural, one {bir gündə} other {# gündə}} yaradıldı",
  "notifications.policy.filter_new_accounts_title": "Yeni hesablar",
  "notifications.policy.filter_not_followers_hint": "Sizi {days, plural, one {bir gündən} other {# gündən}} az müddətdir izləyən insanlar daxildir",
  "notifications.policy.filter_not_followers_title": "Sizi izləməyən insanlar",
  "notifications.policy.filter_not_following_hint": "Onları manual qəbul edənə qədər",
  "notifications.policy.filter_not_following_title": "İzləmədiyiniz insanlar",
  "notifications.policy.title": "Bildirişləri idarə et…",
  "notifications_permission_banner.enable": "Masaüstü bildirişləri fəallaşdır",
  "notifications_permission_banner.title": "Heç nəyi buraxmayın",
  "onboarding.follows.back": "Geri",
  "onboarding.follows.search": "Axtar",
  "onboarding.follows.title": "Başlamaq üçün insanları izləyin",
  "onboarding.profile.discoverable": "Profilimi kəşf edilə bilən et",
  "onboarding.profile.discoverable_hint": "Mastodon-da kəşf edilə bilməni aktivləşdirsəniz, göndərişləriniz axtarış nəticələrində və trendlərdə görünə bilər və profiliniz sizinlə oxşar maraqlara sahib şəxslərə təklif edilə bilər.",
  "onboarding.profile.display_name": "Ekran adı",
  "onboarding.profile.display_name_hint": "Tam adınız və ya ləqəbiniz…",
  "onboarding.profile.note": "Bioqrafiya",
  "onboarding.profile.note_hint": "Digər insanların @adını_çəkə və ya #mövzu_etiketləri istifadə edə bilərsiniz…",
  "onboarding.profile.title": "Profili ayarla",
  "onboarding.profile.upload_avatar": "Profil şəkli yüklə",
  "onboarding.profile.upload_header": "Profil başlığı yüklə",
  "password_confirmation.exceeds_maxlength": "Parol təsdiqi, maksimum parol uzunluğunu aşır",
  "password_confirmation.mismatching": "Parol təsdiqi uyuşmur",
  "picture_in_picture.restore": "Geri qoy",
  "poll.closed": "Bağlandı",
  "poll.refresh": "Təzələ",
  "poll.reveal": "Nəticələrə bax",
  "poll.total_people": "{count, plural, one {# nəfər} other {# nəfər}}",
  "poll.total_votes": "{count, plural, one {# səs} other {# səs}}",
  "poll.vote": "Səs ver",
  "poll.voted": "Bu cavaba səs verdiniz",
  "poll.votes": "{votes, plural, one {# səs} other {# səs}}",
  "poll_button.add_poll": "Bir anket əlavə et",
  "poll_button.remove_poll": "Anketi sil",
  "privacy.change": "Göndəriş gizliliyini dəyişdir",
  "privacy.direct.long": "Göndərişdə adı çəkilən hər kəs",
  "privacy.direct.short": "Şəxsi adçəkmə",
  "privacy.private.long": "Yalnız izləyiciləriniz",
  "privacy.private.short": "İzləyicilər",
  "privacy.public.long": "Mastodon-da olan və olmayan hər kəs",
  "privacy.public.short": "Hər kəsə açıq",
  "privacy.unlisted.short": "Səssiz hər kəsə açıq",
  "privacy_policy.last_updated": "Son güncəlləmə {date}",
  "privacy_policy.title": "Gizlilik Siyasəti",
  "recommended": "Tövsiyə edilən",
  "refresh": "Təzələ",
  "regeneration_indicator.please_stand_by": "Lütfən gözləyin.",
  "regeneration_indicator.preparing_your_home_feed": "Əsas ekran lentiniz hazırlanır…",
  "relative_time.days": "{number} gü",
  "relative_time.full.days": "{number, plural, one {# gün} other {# gün}} əvvəl",
  "relative_time.full.hours": "{number, plural, one {# saat} other {# saat}} əvvəl",
  "relative_time.full.just_now": "indicə",
  "relative_time.full.minutes": "{number, plural, one {# dəqiqə} other {# dəqiqə}} əvvəl",
  "relative_time.full.seconds": "{number, plural, one {# saniyə} other {# saniyə}} əvvəl",
  "relative_time.hours": "{number} sa",
  "relative_time.just_now": "indi",
  "relative_time.minutes": "{number} dəq",
  "relative_time.seconds": "{number} san",
  "relative_time.today": "bu gün",
  "reply_indicator.attachments": "{count, plural, one {# qoşma} other {# qoşma}}",
  "reply_indicator.cancel": "İmtina",
  "reply_indicator.poll": "Anket",
  "report.block": "Əngəllə",
  "report.block_explanation": "Onun göndərişlərini görməyəcəksiniz. O, göndərişlərinizi görə və ya sizi izləyə bilməz. Əngəllədiyinizi anlaya biləcək.",
  "report.categories.legal": "Hüquqi",
  "report.categories.other": "Digər",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Məzmun, bir və ya daha çox server qaydasını pozur",
  "report.category.subtitle": "Ən çox uyuşanı seçin",
  "report.category.title": "Bu {type} ilə bağlı nələrin baş verdiyini bizə deyin",
  "report.category.title_account": "profil",
  "report.category.title_status": "göndəriş",
  "report.close": "Hazırdır",
  "report.comment.title": "Bilməyimizi istədiyiniz başqa nəsə var?",
  "report.forward": "Bura yönləndir: {target}",
  "report.forward_hint": "Hesab, başqa bir serverdəndir. Hesabatın anonim bir kopyası ora da göndərilsin?",
  "report.mute": "Səssizə al",
  "report.mute_explanation": "Onun göndərişlərini görməyəcəksiniz. O, sizi izləməyə və göndərişlərinizi görməyə davam edə bilər, ancaq səssizə alındığını bilməyəcək.",
  "report.next": "Növbəti",
  "report.placeholder": "Əlavə rəylər",
  "report.reasons.dislike": "Bunu bəyənmədim",
  "report.reasons.dislike_description": "Bu, görmək istədiyiniz bir şey deyil",
  "report.reasons.legal": "Qanunsuzdur",
  "report.reasons.legal_description": "Sizin və ya serverinizin olduğu ölkənin qanunlarını pozduğuna inanırsınız",
  "report.reasons.other": "Başqa bir şeydir",
  "report.reasons.other_description": "Problem, digər kateqoriyalara uyğun gəlmir",
  "report.reasons.spam": "Spamdır",
  "report.reasons.spam_description": "Zərərli keçidlər, saxta qarşılıqlı əlaqə və ya təkrarlanan cavablar",
  "report.reasons.violation": "Server qaydalarını pozur",
  "report.reasons.violation_description": "Müəyyən qaydaları pozduğundan xəbərdarsınız",
  "report.rules.subtitle": "Uyğun olanların hamısını seçin",
  "report.rules.title": "Hansı qaydalar pozulub?",
  "report.statuses.subtitle": "Uyğun olanların hamısını seçin",
  "report.statuses.title": "Bu şikayəti dəstəkləyən hər hansısa bir göndəriş var?",
  "report.submit": "Təqdim et",
  "report.target": "{target} şikayət edilir",
  "report.thanks.take_action": "Mastodon-da nə görə biləcəyinizi idarə etmək üçün seçimləriniz bunlardır:",
  "report.thanks.take_action_actionable": "Biz bunu incələdiyimiz müddətdə, siz @{name} ilə bağlı bunları edə bilərsiniz:",
  "report.thanks.title": "Bunu görmək istəmirsiniz?",
  "report.thanks.title_actionable": "Şikayət etdiyiniz üçün təşəkkürlər, məsələyə baxacağıq.",
  "report.unfollow": "@{name} - izləmədən çıxart",
  "report.unfollow_explanation": "Bu hesabı izləyirsiniz. Əsas ekran lentinizdə onun göndərişlərini artıq görmək istəmirsinizsə, onu izləmədən çıxarın.",
  "report_notification.attached_statuses": "{count, plural, one {{count} göndəriş} other {{count} göndəriş}} əlavə edildi",
  "report_notification.categories.legal": "Hüquqi",
  "report_notification.categories.legal_sentence": "qanunsuz məzmun",
  "report_notification.categories.other": "Digər",
  "report_notification.categories.other_sentence": "digər",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Qayda pozuntusu",
  "report_notification.categories.violation_sentence": "qayda pozuntusu",
  "report_notification.open": "Hesabatı aç",
  "search.clear": "Axtarışı təmizlə",
  "search.no_recent_searches": "Son axtarışlar yoxdur",
  "search.placeholder": "Axtar",
  "search.quick_action.account_search": "Uyuşan profillər {x}",
  "search.quick_action.go_to_account": "{x} profilinə get",
  "search.quick_action.go_to_hashtag": "{x} mövzu etiketinə get",
  "search.quick_action.open_url": "URL-ni Mastodon-da aç",
  "search.quick_action.status_search": "Uyuşan göndərişlər {x}",
  "search.search_or_paste": "Axtar və ya URL-ni yapışdır",
  "search_popout.full_text_search_disabled_message": "{domain} domenində mövcud deyil.",
  "search_popout.full_text_search_logged_out_message": "Yalnız giriş edildiyi zaman əlçatandır.",
  "search_popout.language_code": "ISO dil kodu",
  "search_popout.options": "Axtarış seçimləri",
  "search_popout.quick_actions": "Cəld əməliyyatlar",
  "search_popout.recent": "Son axtarışlar",
  "search_popout.specific_date": "müəyyən tarix",
  "search_popout.user": "istifadəçi",
  "search_results.accounts": "Profillər",
  "search_results.all": "Hamısı",
  "search_results.hashtags": "Mövzu etiketləri",
  "search_results.no_results": "Nəticə yoxdur.",
  "search_results.no_search_yet": "Göndərişləri, profilləri və ya mövzu etiketlərini axtarmağa çalışın.",
  "search_results.see_all": "Hamısına bax",
  "search_results.statuses": "Göndərişlər",
  "search_results.title": "\"{q}\" axtar",
  "server_banner.about_active_users": "Son 30 gündə bu serveri istifadə edənlər (aylıq aktiv istifadəçilər)",
  "server_banner.active_users": "aktiv istifadəçilər",
  "server_banner.administered_by": "Administrasiya:",
  "server_banner.is_one_of_many": "{domain}, fediverse-də iştirak etmək üçün istifadə edə biləcəyiniz bir neçə müstəqil Mastodon serverlərindən biridir.",
  "server_banner.server_stats": "Server statistikaları:",
  "sign_in_banner.create_account": "Hesab yarat",
  "sign_in_banner.follow_anyone": "fediverse-dəki hər kəsi izləyin və hamısına xronoloji ardıcıllıqla baxın. Heç bir alqoritm, reklam və ya klikləmə tələsi yoxdur.",
  "sign_in_banner.mastodon_is": "Mastodon, baş verənlərdən xəbərdar olmağın ən yaxşı yoldur.",
  "sign_in_banner.sign_in": "Giriş",
  "sign_in_banner.sso_redirect": "Giriş və ya Qeydiyyat",
  "status.admin_account": "@{name} üçün moderasiya interfeysini aç",
  "status.admin_domain": "{domain} üçün moderasiya interfeysini aç",
  "status.admin_status": "Moderasiya interfeysində bu göndərişi aç",
  "status.block": "Əngəllə: @{name}",
  "status.bookmark": "Əlfəcin",
  "status.cancel_reblog_private": "Təkrar paylaşımı geri al",
  "status.cannot_reblog": "Bu göndəriş təkrar paylaşıla bilməz",
  "status.continued_thread": "Davam edən mövzu",
  "status.copy": "Göndəriş keçidini kopyala",
  "status.delete": "Sil",
  "status.detailed_status": "Detallı danışıq görünüşü",
  "status.direct": "Şəxsi olaraq adını çək: @{name}",
  "status.direct_indicator": "Şəxsi olaraq adını çək",
  "status.edit": "Düzəliş et",
  "status.edited": "Son düzəliş {date}",
  "status.edited_x_times": "{count, plural, one {{count} dəfə} other {{count} dəfə}} düzəliş edilib",
  "status.favourite": "Sevimli",
  "status.filter": "Bu göndərişi filtrlə",
  "status.history.created": "{name}, {date} yaratdı",
  "status.history.edited": "{name}, {date} düzəliş etdi",
  "status.load_more": "Daha çoxunu yüklə",
  "status.media.open": "Açmaq üçün kliklə",
  "status.media.show": "Göstərmək üçün kliklə",
  "status.media_hidden": "Media gizlidir",
  "status.mention": "Adını çək: @{name}",
  "status.more": "Daha çox",
  "status.mute": "@{name} - səssizə al",
  "status.mute_conversation": "Danışığın səsini kəs",
  "status.open": "Bu göndərişi genişləndir",
  "status.pin": "Profildə sanc",
  "status.quote_error.filtered": "Bəzi filtrlərinizə görə gizlidir",
  "status.quote_error.not_available": "Göndəriş əlçatmazdır",
  "status.quote_error.pending_approval": "Göndəriş gözləmədədir",
  "status.quote_post_author": "@{name} göndərişini sitat gətirdi",
  "status.read_more": "Daha çoxunu oxu",
  "status.reblog": "Təkrar paylaş",
  "status.reblogged_by": "{name} təkrar paylaşdı",
  "status.reblogs.empty": "Hələ heç kim bu göndərişi təkrar paylaşmayıb. Kimsə paylaşdığı zaman, burada görünəcək.",
  "status.remove_bookmark": "Əlfəcini sil",
  "status.remove_favourite": "Sevimlilərdən sil",
  "status.replied_in_thread": "Mövzuda cavablandırıldı",
  "status.replied_to": "Cavab verildi: {name}",
  "status.reply": "Cavabla",
  "status.replyAll": "Mövzuda cavab ver",
  "status.report": "Bildir: @{name}",
  "status.revoke_quote": "@{name} - göndərişindən mənim göndərişimi sil",
  "status.sensitive_warning": "Həssas məzmun",
  "status.share": "Paylaş",
  "status.show_less_all": "Hamısı üçün daha az göstər",
  "status.show_more_all": "Hamısı üçün daha çox göstər",
  "status.show_original": "Orijinalı göstər",
  "status.title.with_attachments": "{user} {attachmentCount, plural, one {bir qoşma} other {{attachmentCount} qoşma}} paylaşdı",
  "status.translate": "Tərcümə et",
  "status.translated_from_with": "{provider} ilə {lang} dilindən tərcümə edilib",
  "status.uncached_media_warning": "Önizləmə mövcud deyil",
  "status.unmute_conversation": "Danışığın səsini aç",
  "status.unpin": "Profil sancağı götür",
  "subscribed_languages.lead": "Dəyişiklikdən sonra əsas ekran və siyahı zaman xəttinizdə yalnız seçdiyiniz dillərdəki göndərişlər görünəcək. Bütün dillərdə göndəriş almaq üçün heç birini seçməyin.",
  "subscribed_languages.save": "Dəyişiklikləri saxla",
  "subscribed_languages.target": "{target} üçün abunə olunmuş dilləri dəyişdir",
  "tabs_bar.home": "Ana səhifə",
  "tabs_bar.menu": "Menyu",
  "tabs_bar.notifications": "Bildirişlər",
  "tabs_bar.publish": "Yeni göndəriş",
  "tabs_bar.search": "Axtar",
  "terms_of_service.effective_as_of": "{date} etibarilə qüvvədə",
  "terms_of_service.title": "Xidmət Şərtləri",
  "terms_of_service.upcoming_changes_on": "{date} tarixində ediləcək dəyişikliklər",
  "time_remaining.days": "{number, plural, one {# gün} other {# gün}} qalıb",
  "time_remaining.hours": "{number, plural, one {# saat} other {# saat}} qalıb",
  "time_remaining.minutes": "{number, plural, one {# dəqiqə} other {# dəqiqə}} qalıb",
  "time_remaining.moments": "Bir neçə dəqiqə qalıb",
  "time_remaining.seconds": "{number, plural, one {# saniyə} other {# saniyə}} qalıb",
  "trends.counter_by_accounts": "Son {days, plural, one {bir gündə} other {{days} gündə}} {count, plural, one {{counter} nəfər} other {{counter} nəfər}}",
  "trends.trending_now": "İndi trenddədir",
  "ui.beforeunload": "Mastodon-u tərk etsəniz, qaralamanız itəcək.",
  "units.short.billion": "{count} mlyrd",
  "units.short.million": "{count} mlyn",
  "units.short.thousand": "{count} min",
  "upload_area.title": "Yükləmək üçün sürüklə və burax",
  "upload_button.label": "Təsvir, video və ya səs faylı əlavə et",
  "upload_error.limit": "Fayl yükləmə limiti aşılıb.",
  "upload_error.poll": "Anketlərdə fayl yükləməyə icazə verilmir.",
  "upload_form.drag_and_drop.instructions": "Bir media qoşmasını daşımaq üçün boşluq və ya enter düyməsinə basın. Sürükləmə zamanı, media qoşmasını hər hansısa bir yönə hərəkət etdirmək üçün ox düymələrini istifadə edin. Media qoşmasını yeni mövqeyinə buraxmaq üçün təkrar boşluq və ya enter düyməsinə basın, ləğv etmək üçün escape düyməsinə basın.",
  "upload_form.drag_and_drop.on_drag_cancel": "Sürükləmə ləğv edilib. {item} media qoşması buraxıldı.",
  "upload_form.drag_and_drop.on_drag_end": "{item} media qoşması buraxıldı.",
  "upload_form.drag_and_drop.on_drag_over": "{item} media qoşması daşındı.",
  "upload_form.drag_and_drop.on_drag_start": "{item} media qoşması alındı.",
  "upload_form.edit": "Düzəliş et",
  "upload_progress.label": "Yüklənir...",
  "upload_progress.processing": "Emal edilir…",
  "username.taken": "Bu istifadəçi adı götürülüb. Başqasını sınayın",
  "video.close": "Videonu bağla",
  "video.download": "Faylı endir",
  "video.exit_fullscreen": "Tam ekrandan çıx",
  "video.expand": "Videonu genişləndir",
  "video.fullscreen": "Tam ekran",
  "video.hide": "Videonu gizlət",
  "video.mute": "Səsi kəs",
  "video.pause": "Fasilə ver",
  "video.play": "Oxut",
  "video.skip_backward": "Geri ötür",
  "video.skip_forward": "İrəli ötür",
  "video.unmute": "Səsi aç",
  "video.volume_down": "Həcmi azalt",
  "video.volume_up": "Həcmi artır",
  "visibility_modal.button_title": "Görünməni ayarla",
  "visibility_modal.header": "Görünmə və qarşılıqlı əlaqə",
  "visibility_modal.helper.unlisted_quoting": "İnsanlar sizdən sitat gətirdiyi zaman, onların göndərişləri də trend zaman xəttindən gizlədiləcək.",
  "visibility_modal.quote_followers": "Yalnız izləyicilər",
  "visibility_modal.quote_public": "Hər kəs"
}
